export const SkeletonPictureArticleCard = () => {
  return (
    <div className='flex w-full min-h-[123px] sm:min-h-[243px] cursor-pointer flex-row rounded-xl border border-gray-200 bg-white text-gray-900 shadow-md sm:shadow-transparent'>
      <div className='w-[164px] sm:w-[430px] h-full rounded-l-xl overflow-hidden bg-gray-200 animate-pulse' />

      <div className='flex flex-col gap-3 px-3 py-4 rounded-r-xl flex-grow justify-between'>
        <div className='flex flex-col gap-2'>
          <div className='h-4 w-20 rounded bg-gray-200 animate-pulse' />
          <div className='h-6 w-3/4 rounded bg-gray-200 animate-pulse' />
          <div className='h-4 w-full rounded bg-gray-200 animate-pulse' />
        </div>

        <div className='flex flex-row justify-between items-center'>
          <div className='flex flex-col justify-between gap-1'>
            <div className='h-4 w-24 rounded bg-gray-200 animate-pulse' />
            <div className='h-4 w-20 rounded bg-gray-200 animate-pulse' />
          </div>
        </div>
      </div>
    </div>
  );
};
